<template>
  <div>
    <SfeLabel class="mb-1">Request Body (JSON)</SfeLabel>
    <SfeTextarea
      v-model="localBody"
      rows="6"
      placeholder='{ "key": "value" }'
      @input="onInput"
      class="mb-2"
    />
    <SfeStatusBadge v-if="bodyError" intent="critical" variant="outline" class="mb-2">
      {{ bodyError }}
    </SfeStatusBadge>
    <div v-if="method === 'GET' && !bodyError && localBody.trim()">
      <SfeLabel class="mb-1">Preview URL with Query Params</SfeLabel>
      <div class="bg-light p-2 rounded">
        <code>{{ previewUrl }}</code>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['method', 'body'],
  data() {
    return {
      localBody: this.body || '',
      bodyError: ''
    }
  },
  computed: {
    previewUrl() {
      if (this.method !== 'GET' || !this.localBody.trim() || this.bodyError) return ''
      try {
        const obj = JSON.parse(this.localBody)
        const params = Object.entries(obj)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&')
        return params ? `?${params}` : ''
      } catch {
        return ''
      }
    }
  },
  watch: {
    body: {
      immediate: true,
      handler(val) {
        this.localBody = val || ''
      }
    }
  },
  methods: {
    onInput() {
      this.bodyError = ''
      if (this.localBody.trim()) {
        try {
          JSON.parse(this.localBody)
        } catch {
          this.bodyError = 'Invalid JSON body'
        }
      }
      this.$emit('update-body', this.localBody)
    }
  }
}
</script>
